export enum ReasonCategory {
  NotScamLikely = 'Not a Scam Likely call',
  ScamLikely = 'Was a Scam Likely call',
  WrongCategory = 'Wrong category indicated'
}

export enum NotScamReason {
  KnowPersonally = 'I know the caller personally (friend, family, work associate, etc.)',
  PriorEngagement = 'The caller is a business/organization that I have prior engagement with (financial institution, pharmacy, retail store, etc.)',
  EventNotification = 'This is an event notification (weather alert, school notification, etc.)'
}

export enum ScamReason {
  IRS = 'IRS',
  CreditCard = 'Credit Card',
  Debt = 'Debt Management',
  PC = 'PC Support',
  Other = 'Other'
}

export enum WrongCategoryReason {
  Telemarketing = 'Telemarketing',
  Political = 'Political',
  Survey = 'Survey',
  Charity = 'Charity',
  Prison = 'Prison/Jail',
  PotentialSpam = 'Potential Spam',
  Other = 'Other'
}

export type CallDetailsInformation = {
  number: string;
  name: string;
  date: string | null;
  time: string | null;
  category: ReasonCategory | null;
  reason: NotScamReason | ScamReason | WrongCategoryReason | null;
  isPrerecorded: boolean;
}
